'use es6';

export var DOMAIN_INVALID = 'DOMAIN_INVALID';
export var TARGET_PAGE_ERROR = 'TARGET_PAGE_ERROR';
export var WEBSITE_GRADER_ERROR = 'WEBSITE_GRADER_ERROR';